import { Route } from "@angular/router";
import { authGuard, merchantGuard, tenantGuard } from "app/core/auth/guards";
import { LayoutComponent } from "app/core/components/layout/layout.component";
import { ROUTES_CONSTANT } from "./core/constants";

export const appRoutes: Route[] = [
  {
    path: ROUTES_CONSTANT.auth.relativePath,
    component: LayoutComponent,
    data: { layout: "empty" },
    children: [
      {
        path: ROUTES_CONSTANT.empty,
        loadChildren: () => import("app/pages/auth/auth.routes"),
      },
    ],
  },
  {
    path: ROUTES_CONSTANT.forbidden.relativePath,
    component: LayoutComponent,
    data: { layout: "empty" },
    children: [
      {
        path: ROUTES_CONSTANT.empty,
        loadComponent: () => import("app/pages/forbidden/forbidden.component"),
      },
    ],
  },
  {
    path: ROUTES_CONSTANT.payin.relativePath,
    canActivateChild: [authGuard, tenantGuard, merchantGuard],
    component: LayoutComponent,
    children: [
      {
        path: ROUTES_CONSTANT.empty,
        loadChildren: () => import("app/pages/payin/payin.routes"),
      },
    ],
  },
  {
    path: ROUTES_CONSTANT.payout.relativePath,
    canActivateChild: [authGuard, tenantGuard, merchantGuard],
    component: LayoutComponent,
    children: [
      {
        path: ROUTES_CONSTANT.empty,
        loadChildren: () => import("app/pages/payout/payout.routes"),
      },
    ],
  },
  {
    path: ROUTES_CONSTANT.users.relativePath,
    canActivateChild: [authGuard, tenantGuard, merchantGuard],
    component: LayoutComponent,
    children: [
      {
        path: ROUTES_CONSTANT.empty,
        loadChildren: () => import("app/pages/user/user.routes"),
      },
    ],
  },
  {
    path: ROUTES_CONSTANT.balance.relativePath,
    canActivateChild: [authGuard, tenantGuard, merchantGuard],
    component: LayoutComponent,
    children: [
      {
        path: ROUTES_CONSTANT.empty,
        loadChildren: () => import("app/pages/balance/balance.routes"),
      },
    ],
  },
  {
    path: "",
    redirectTo: ROUTES_CONSTANT.payinDashboard.absolutePath,
    pathMatch: "full",
  },
  // Antes redirigía a /auth/sign-in (login propio). Ahora cualquier ruta protegida
  // dispara authGuard -> keycloak.login() si no hay sesión, así que el dashboard
  // es una entrada válida incluso para un usuario no autenticado.
  { path: "**", redirectTo: ROUTES_CONSTANT.payinDashboard.absolutePath },
];
